//
import router from '../router/index'
import myAxios from '../functions/myAxios';
import {
  showSnackbar
} from "../components/MySnackbar/globalActions";

const AuthModule = {
  // state: {
  //   user: null
  // },
  mutations: {
    login(
      //state, payload
    ) {
      // state.user = payload
    },
    logout() {},
  },
  actions: {
    async login({
      commit
    }, payload) {
      try {
        if (!payload || !payload.username || !payload.password) {
          showSnackbar("اطلاعات ورودی ناقص است", 'error');
          return;
        }
        let res = await myAxios({
          method: 'POST',
          url: '/api/login',
          data: payload,
        });
        // console.log(res);
        if (res && res.data && res.data.auth && res.data.user && res.data.jwt_key) {
          sessionStorage.setItem('auth', JSON.stringify(res.data.user))
          sessionStorage.setItem('jwt', JSON.stringify(res.data.jwt_key))
          sessionStorage.setItem('menus', JSON.stringify(res.data.menus))
          commit('login'
            //, res.data.user
          )
          router.push('/')

          // return res.data
        } else {
          showSnackbar("اطلاعات ورودی معتبر نیست", 'error');
        }
      } catch (e) {
        console.log(e);
      }
    },
    logout({
      commit
    }) {
      try {
        sessionStorage.removeItem('auth')
        sessionStorage.removeItem('jwt')
        sessionStorage.removeItem('menus')
        commit('logout')
        router.push('/login')
      } catch (e) {
        console.log(e);
      }
    },
  }
}

export default AuthModule
